import { documentHasElements } from "modules/dom";

documentHasElements(".js-scroll-container-block", (scrollContainerBlocks) => {
    scrollContainerBlocks.forEach((blockEl) => {
        const block = blockEl as HTMLElement;

        const header = document.querySelector<HTMLElement>(".header");
        const getHeaderHeight = (): number => header?.offsetHeight ?? 0;

        // Save original HTML before any DOM manipulation so we can restore on resize
        const originalHTML = block.innerHTML;

        let isDesktop = false;
        let scrollCleanup: (() => void) | null = null;
        let resizeVarCleanup: (() => void) | null = null;

        const initDesktop = () => {
            if (isDesktop) return;
            isDesktop = true;

            const slides = Array.from(block.querySelectorAll<HTMLElement>(".slider__content"));
            if (slides.length === 0) return;

            // Build new text + image panels
            const textPanel = document.createElement("div");
            textPanel.className = "scb-text-panel";

            const imagePanel = document.createElement("div");
            imagePanel.className = "scb-image-panel";

            slides.forEach((slide, i) => {
                const imageEl = slide.querySelector<HTMLElement>(".col.image, .col.video");
                const textEl  = slide.querySelector<HTMLElement>(".col.text");

                const textItem = document.createElement("div");
                textItem.className = "scb-text-item";
                textItem.dataset.index = String(i);
                if (textEl) textItem.appendChild(textEl);
                textPanel.appendChild(textItem);

                const imgItem = document.createElement("div");
                imgItem.className = `scb-image-item${i === 0 ? " active" : ""}`;
                imgItem.dataset.index = String(i);
                if (imageEl) imgItem.appendChild(imageEl);
                imagePanel.appendChild(imgItem);
            });

            // Replace DOM, swap layout classes
            block.classList.remove("grid", "grid__gap");
            block.classList.add("scb-v2");
            block.innerHTML = "";
            block.appendChild(textPanel);
            block.appendChild(imagePanel);

            // Keep header height in a CSS variable
            const setHeaderVar = () => block.style.setProperty("--header-h", `${getHeaderHeight()}px`);
            setHeaderVar();
            window.addEventListener("resize", setHeaderVar, { passive: true });
            resizeVarCleanup = () => window.removeEventListener("resize", setHeaderVar);

            // Switch image based on which text item is closest to viewport mid
            const textItems = Array.from(textPanel.querySelectorAll<HTMLElement>(".scb-text-item"));
            const imgItems  = Array.from(imagePanel.querySelectorAll<HTMLElement>(".scb-image-item"));

            const activateImage = (index: number) => {
                imgItems.forEach((img) => {
                    img.classList.toggle("active", img.dataset.index === String(index));
                });
            };

            let ticking = false;
            const onScroll = () => {
                if (ticking) return;
                ticking = true;
                requestAnimationFrame(() => {
                    const headerH = getHeaderHeight();
                    const viewportMid = headerH + (window.innerHeight - headerH) / 2;
                    let closest = 0;
                    let minDist = Infinity;

                    textItems.forEach((item, i) => {
                        const rect = item.getBoundingClientRect();
                        const itemCenter = rect.top + rect.height / 2;
                        const dist = Math.abs(itemCenter - viewportMid);
                        if (dist < minDist) {
                            minDist = dist;
                            closest = i;
                        }
                    });

                    activateImage(closest);
                    ticking = false;
                });
            };

            window.addEventListener("scroll", onScroll, { passive: true });
            scrollCleanup = () => window.removeEventListener("scroll", onScroll);
            onScroll();
        };

        const destroyDesktop = () => {
            if (!isDesktop) return;
            isDesktop = false;

            if (scrollCleanup)    { scrollCleanup();    scrollCleanup = null; }
            if (resizeVarCleanup) { resizeVarCleanup(); resizeVarCleanup = null; }

            // Restore original slider HTML and class list
            block.innerHTML = originalHTML;
            block.classList.remove("scb-v2");
            block.classList.add("grid", "grid__gap");
            block.style.removeProperty("--header-h");
        };

        const checkBreakpoint = () => {
            if (window.innerWidth >= 1024) {
                initDesktop();
            } else {
                destroyDesktop();
            }
        };

        // Initial check
        checkBreakpoint();

        // Debounced resize handler
        let resizeTimer: ReturnType<typeof setTimeout>;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(checkBreakpoint, 200);
        }, { passive: true });
    });
});
